import {
  Button,
  FormLabel,
  Input,
  Modal,
  ModalDialog,
  Textarea,
} from "@mui/joy";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

interface DynamicEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (data: any) => void;
  values: FormData[];
}
interface FormData {
  value: string;
  label: string;
  property?: string;
  error?: string;
}

const DynamicEditModal: React.FC<DynamicEditModalProps> = ({
  isOpen,
  onClose,
  onSave,
  values,
}) => {
  const [formData, setFormData] = useState<FormData[]>([]);
  useEffect(() => {
    setFormData(values);
  }, [values]);
  const handleInputChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    index: number,
    property?: string
  ) => {
    const { name, value } = e.target;

    const errors: Partial<Record<string, string>> = {};
    if (!value.trim()) {
      errors[name] = "Dit veld is verplicht.";
    }

    setFormData((prevData: FormData[]) => {
      const newData = [...prevData];
      newData[index] = {
        ...newData[index],
        value: value,
        error: errors[name],
        property: property,
      };
      return [...newData]; // Make sure to spread the array as well
    });
  };
  const handleSave = () => {
    const hasErrors = formData.some((item) => !!item.error);

    if (!hasErrors) {
      onSave(formData);
      onClose();
    } else {
      toast.error("Gelieve alle velden in te vullen.");
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <React.Fragment>
        <ModalDialog>
          <div className="modal">
            <h3>Gegevens aanpassen</h3>
            <form className="formModal">
              {formData.map((data, index) => (
                <div key={index}>
                  <FormLabel
                    sx={{ marginTop: "1rem", paddingBottom: "0.5rem" }}
                  >
                    {data.label}
                  </FormLabel>
                  <Textarea
                    name={data.label}
                    defaultValue={data.value}
                    minRows={1}
                    maxRows={10}
                    onChange={(e) =>
                      handleInputChange(e, index, data?.property)
                    }
                  />
                  <div style={{ color: "red" }}>{data.error}</div>
                </div>
              ))}
              <div>
                <Button
                  id="addButton"
                  variant="outlined"
                  color="neutral"
                  sx={{ backgroundColor: "#484494" }}
                  type="button"
                  onClick={handleSave}
                >
                  Save
                </Button>
                <Button
                  id="addButton"
                  variant="outlined"
                  color="neutral"
                  sx={{ backgroundColor: "#484494", marginTop: "1rem" }}
                  type="button"
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </ModalDialog>
        <ToastContainer />
      </React.Fragment>
    </Modal>
  );
};

export default DynamicEditModal;
